import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Icon_-_Upload",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 47 47",
	style: { enableBackground: "new 0 0 47 47" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_1506",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_239",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				cx: 34,
				cy: 34,
				r: 12
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_545",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				x1: 34,
				y1: 40,
				x2: 34,
				y2: 28
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_546",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				x1: 34,
				y1: 28,
				x2: 29.5,
				y2: 32.5
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_547",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				x1: 34,
				y1: 28,
				x2: 38.5,
				y2: 32.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4291",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M16,40H4c-1.7,0-3-1.3-3-3V4c0-1.7,1.3-3,3-3h21.3c0.8,0,1.6,0.3,2.1,0.9l5.7,5.7 C33.7,8.2,34,8.9,34,9.7V16"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4292",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				d: "M10,12.2c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4293",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				d: "M10,12.2c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4294",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M23.7,18.7L22,16c-0.5-0.7-1.4-0.9-2.1-0.4c-0.2,0.1-0.3,0.2-0.4,0.4l-4,5.7l-2.5-2 c-0.6-0.5-1.6-0.4-2.1,0.2c0,0-0.1,0.1-0.1,0.1L7,28h9"
			})
		]
	})
});
export { SvgUpload as ReactComponent };
